<template>
  <div class="s-setting-container no-border">
    <div class="header">
      My Profile
    </div>
    <div class="card">
      <div class="card-header mt-5">
        <div>Account Information</div>
      </div>
      <div class="flex-row align-center">
        <div class="card-account">
          {{ current.firstName.charAt(0) + current.lastName.charAt(0) }}
        </div>
        <span class="sac__font-16 n40">{{ adminRole }} • {{ corporationName }}</span>
      </div>
      <span class="card-header">Email</span>
      <span class="sac__font-16 n60">{{ current.email }}</span>
      <a class="sac__font-16 mt-5 underline" href="set-password">Reset Dashboard Password</a>
    </div>
    <div class="card">
      <div class="card-header mt-5">
        <div>Notification Settings</div>
      </div>
      <span class="sac__font-16 mt-5">Email</span>
      <span v-for="item in notificationSettings" :key="item" class="sac__font-16 n60">{{ item }} </span>
      <span v-for="item in serviceNotifications" :key="item" class="sac__font-16 n60">{{ item.category }} Service Requests </span>
      <div v-if="notificationSettingsLead" class="flex-column">
        <span v-if="partnerSettings.LEAD_CRITICAL" class="sac__font-16 n60">Lead Critical Alert </span>
        <span v-if="partnerSettings.LEAD_URGENT" class="sac__font-16 n60">Lead Urgent Alert </span>
        <span v-if="partnerSettings.LEAD_SUMMARY" class="sac__font-16 n60">Daily Summary Report </span>
      </div>
    </div>
    <span class="sac__font-16 mt-5">Some settings are view-only. Please contact your admin(s) to request any adjustments</span>

    <ProcessOverlay
      :show="updating"
      text="Saving"
    />
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

import { mapGetters, mapState } from 'vuex';

export default {
  name: 'AccountSection',
  components: {
    ProcessOverlay,
  },
  mixins: [partnerSettingsMixin],
  props: {
    currentCorporation: Object,
    partnerSettings: Object,
    partnerIndustry: Array,
    update: Function,
    screen: String,
  },
  data() {
    const {
      corporationName = '',
      displayName = '',
      website = '',
      phone = '',
      phoneCountry = '',
      psmId = null,
      corpStatus = '',
      status = '',
      hsCompanyId,
      engagementLevel = '',
      serviceProvider,
      industry = '',
      psmFirstName = '',
      psmEmail = '',
    } = this.currentCorporation;
    const notificationSettings = this.partnerSettings.ALERT_EMAIL_PREFERENCE;
    return {
      corporationName,
      displayName,
      website,
      hsCompanyId,
      industry,
      phone,
      phoneCountry,
      errorObj: {},
      updating: false,
      psmId,
      corpStatus,
      status,
      engagementLevel,
      serviceProvider,
      psmFirstName,
      psmEmail,
      notificationSettings,
      showStatusWarning: false,
      notificationSettingsLead: undefined,
      serviceNotifications: [],
      newStatus: '',
    };
  },
  computed: {
    ...mapState({
      current: (state) => state.admin.current,
    }),
    ...mapGetters([
      'adminRole',
      'adminPermissions',
      'todayEvents',
    ]),
  },
  watch: {
    async contacts(nv) {
      const mc = nv.filter((x) => x.contactType === 'ServiceReq');
      this.serviceNotifications = mc?.filter((x) => x.email === this.current.email);
      this.notificationSettingsLead = this.partnerSettings.LEAD_EMAIL.find((x) => x === this.current.email);
    },
  },
  async mounted() {
    await this.$store.dispatch('getPartnerContacts', {
      corpId: this.currentCorporation.id,
    });
  },
};
</script>
<style lang="scss" scoped>
.header {
    font-size: 22px;
}
.card {
    padding: 10px 20px;
    display: flex;
    flex-direction: column;
    border: 1px solid #C4C5CC;
    border-radius: 4px;
    .card-header {
        font-size: 18px;
        font-weight: 500;
    }
    .card-account {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 14px 16px;
        font-size: 18px;
        font-weight: 600;
        color: $N65;
        border: 2px $N30 solid;
        border-radius: 50%;
        margin: 20px 15px 20px 0px;
    }
}
</style>
